module.exports = __webpack_public_path__ + "img/italy.67451503.svg";